var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"copyright-footer"},[_c('div',{staticClass:"copyright-footer-text fs-10 pt-30"},[_vm._v("\n\t\tCopyright © "+_vm._s(_vm.version)+" "),(!_vm.Helper.isPiquetur)?[_vm._v("iTrack Brasil")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }